import { TColumnProps } from './table';
import { getListDefaultState } from '../GetListDefaultState/GetListDefaultState';

export const sorter = ({ key, sortable }: TColumnProps) => {
  if(!sortable || key === 'actions') {
    return {};
  }
  const { sorting } = getListDefaultState({ page: 1, take: 10 });
  const defaultSortOrder = sorting?.field === key ? sorting?.order === 'ASC' ? 'ascend' : 'descend' : undefined;

  return {
    defaultSortOrder,
    sortDirections: ['descend', 'ascend'],
    sorter: (a: any, b: any) => {
      if(typeof a[`__${key}`] === 'string' && typeof b[`__${key}`] === 'string'){
        return a[`__${key}`].localeCompare(b[`__${key}`]);
      }
      return a[`__${key}`] - b[`__${key}`]
    },
  }

}
